'use strict';

/* eslint-disable no-bitwise */

const formValidation = require('../components/customFormValidation');

/**
 * IDでログインフォームを取得する
 *
 * @param {string} formID フォームID
 * @returns {object} form
 */
function getForm(formID) {
    const form = document.getElementById(formID);
    return form;
}

/**
 * XMLHttpRequest.send() メソッドを使用して簡単に送信できる、
 * フォーム フィールドとその値を表すキーと値のペアのセットを簡単に作成する方法を提供します。
 *
 * @param {object} form フォーム
 * @returns {object} formData
 */
function createFormData(form) {
    const formData = new FormData(form);
    return formData;
}

module.exports = {
    contactSubmit: function () {
        let areaTop = 0;
        if ($(window).width() < 768) {
            areaTop = 100;
        } else {
            areaTop = 150;
        }
        const form = getForm('contact-form');
        const $form = $(form);
        $form.on('submit', async (e) => {
            e.preventDefault();
            // 処理前にエラーメッセージを隠す
            $('.alert', '#form-error').remove();
            $form.spinner().start();
            try {
                const url = $form.attr('action');
                const formData = createFormData(form);
                // フォームをAjaxでPOST送信する部品を用いる
                const postForm = require('sswd_base/components/XPostForm');
                const data = await postForm(url, formData);
                // --- レスポンスデータにredirectUrlが含まれる場合
                if (data.redirectUrl) {
                    // フォームをリセットする(ブラウザーバック時に値が復元されないようにする)
                    form.reset();
                    // redirectUrlに移動
                    window.location.href = data.redirectUrl;
                    return;
                }
                // --- レスポンスデータにredirectUrlが含まれない場合
                formValidation(form, data);
                // エラーを投げる
                throw new Error();
            } catch (err) {
                $(() => {
                    let top = 0;
                    $('.is-invalid').each((index, element) => {
                        let newTop = $(element).parent().offset().top;
                        if (top === 0 || top > newTop) {
                            top = newTop - areaTop;
                        }
                    });
                    $('html, body').animate(
                        {
                            scrollTop: top,
                        },
                        'fast'
                    );
                });
                $form.spinner().stop();
            }
        });
    },

    productFocus: function () {
        const form = getForm('product-code');
        const $form = $(form);
        $form.on('change', async (e) => {
            e.preventDefault();
            $('#product-result').text('');
            const pid = $form.val();
            if (!pid) {
                return;
            }
            $form.spinner().start();
            const link = $form.data('link');
            const url = `${link}?pid=${pid}`;
            $.ajax(url)
                .done(function (data) {
                    // 商品名を設定する
                    $('#product-result').text(data.productName);
                })
                .always(function () {
                    $form.spinner().stop();
                });
        });
    },

    // チェックボックス活性
    submitLogic: function () {
        $(function () {
            $('#form-submit').prop('disabled', true);
            $('#agreement-flag').on('click', function () {
                if ($(this).prop('checked') === false) {
                    $('#form-submit').prop('disabled', true);
                } else {
                    $('#form-submit').prop('disabled', false);
                }
            });
        });
    },

    // オンロード時の送り主情報表示
    onLoad: function () {
        $(window).on('load', function () {
            const str = $('input:radio[name="dwfrm_contact_contact_type"]:checked').val();
            if (['0'].includes(str)) {
                $('#hide-area1').show();
                $('#product-code').prop('disabled', false);
                $('#product-code').prop('readonly', true);
            } else {
                $('#hide-area1').hide();
            }
            if (['3', '4', '5', '6'].includes(str)) {
                $('#hide-area2').show();
                $('#order-number').prop('disabled', false);
                $('#order-number').prop('readonly', true);
            } else {
                $('#hide-area2').hide();
            }
        });
    },

    // ラジオ変更時の送り主情報表示
    radioLogic: function () {
        $(function () {
            $('input[name="dwfrm_contact_contact_type"]:radio').change(function () {
                const str = $('input:radio[name="dwfrm_contact_contact_type"]:checked').val();
                if (['0'].includes(str)) {
                    $('#hide-area1').fadeIn(1000);
                    $('#product-code').prop('disabled', false);
                } else {
                    $('#hide-area1').hide();
                    $('#product-code').prop('disabled', true);
                }
                if (['3', '4', '5', '6'].includes(str)) {
                    $('#hide-area2').fadeIn(1000);
                    $('#order-number').prop('disabled', false);
                } else {
                    $('#hide-area2').hide();
                    $('#order-number').prop('disabled', true);
                }
            });
        });
    },

    error: function () {
        $(function () {
            let areaTop = 0;
            if ($(window).width() < 768) {
                areaTop = 100;
            } else {
                areaTop = 150;
            }
            $('#form-submit').click(function () {
                $(() => {
                    let top = 0;
                    $('.is-invalid').each((index, element) => {
                        let newTop = $(element).parent().offset().top;
                        if (top === 0 || top > newTop) {
                            top = newTop - areaTop;
                        }
                    });
                    if (top !== 0) {
                        $('html, body').animate(
                            {
                                scrollTop: top,
                            },
                            'fast'
                        );
                    }
                });
            });
        });
    },
};
